import React, {Component} from 'react';
import cookie from 'react-cookies';

import '../App.css';

class Navigation extends Component{
    //call the constructor method
    constructor(props){
        super(props);
    }
    
    componentWillMount(){
        
    }

    geProfile(e){
        e.preventDefault();
        localStorage.setItem('userId', 0);

        if (cookie.load('cookieId')) {
            this.props.history.push('/profile');
            window.location.reload(false);
        } else {
            this.props.header.toggleSignupPopup();
        }
    }

    render(){
        return(            
            <nav>
                <ul>
                    <li className={this.props.active == 1 ? 'active' : ''} title={this.props.dataLanguage["home"]}><a href="/"><img alt="" src="/assets/images/icons/home.png" /></a></li>
                    <li className={this.props.active == 2 ? 'active' : ''} title={this.props.dataLanguage["profile"]}><a href="" onClick={this.geProfile.bind(this)}><img alt="" src="/assets/images/icons/profile.png" /></a></li>
                    <li className={this.props.active == 3 ? 'active' : ''} title={this.props.dataLanguage["assets"]}><a href="/assets"><img alt="" src="/assets/images/icons/chest.png" /></a></li>
                    <li className={this.props.active == 4 ? 'active' : ''} title={this.props.dataLanguage["games"]}><a href="/games"><img alt="" src="/assets/images/icons/game-1.png" /></a></li>
                    <li className={this.props.active == 5 ? 'active' : ''} title={this.props.dataLanguage["currency"]}><a href="/currency"><img alt="" src="/assets/images/icons/currency.png" /></a></li>
                    <li className={this.props.active == 6 ? 'active' : ''} title={this.props.dataLanguage["store"]}><a href="/store"><img alt="" src="/assets/images/icons/cart.png" /></a></li>
                </ul>
            </nav>
        )
    }
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/components/Navigation.js